import React from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { StatCardsSkeleton } from "~/components/ui/skeletons";

interface PaymentStatsProps {
  stats:
    | {
        total: number;
        week: number;
        month: number;
        count: number;
      }
    | undefined;
  isLoading: boolean;
  hasDateFilter?: boolean;
}

const StatsCards: React.FC<PaymentStatsProps> = ({
  stats,
  isLoading,
  hasDateFilter = false,
}) => {
  if (isLoading) {
    return <StatCardsSkeleton count={hasDateFilter ? 2 : 4} />;
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
      {!hasDateFilter && (
        <>
          <Card>
            <CardHeader className="p-4 pb-0">
              <CardTitle className="text-sm font-medium">
                Total de Pagos
              </CardTitle>
              <CardDescription>Histórico</CardDescription>
            </CardHeader>
            <CardContent className="p-4 pt-2">
              <div className="text-2xl font-bold">
                ${stats?.total?.toLocaleString() || 0}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="p-4 pb-0">
              <CardTitle className="text-sm font-medium">
                Pagos Esta Semana
              </CardTitle>
              <CardDescription>Últimos 7 días</CardDescription>
            </CardHeader>
            <CardContent className="p-4 pt-2">
              <div className="text-2xl font-bold">
                ${stats?.week?.toLocaleString() || 0}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="p-4 pb-0">
              <CardTitle className="text-sm font-medium">
                Pagos Este Mes
              </CardTitle>
              <CardDescription>Desde inicio del mes</CardDescription>
            </CardHeader>
            <CardContent className="p-4 pt-2">
              <div className="text-2xl font-bold">
                ${stats?.month?.toLocaleString() || 0}
              </div>
            </CardContent>
          </Card>
        </>
      )}

      {hasDateFilter && (
        <Card>
          <CardHeader className="p-4 pb-0">
            <CardTitle className="text-sm font-medium">
              Total de Pagos
            </CardTitle>
            <CardDescription>En el periodo seleccionado</CardDescription>
          </CardHeader>
          <CardContent className="p-4 pt-2">
            <div className="text-2xl font-bold">
              ${stats?.total?.toLocaleString() || 0}
            </div>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardHeader className="p-4 pb-0">
          <CardTitle className="text-sm font-medium">
            Cantidad de Pagos
          </CardTitle>
          <CardDescription>
            {hasDateFilter ? "En el periodo seleccionado" : "Total registrados"}
          </CardDescription>
        </CardHeader>
        <CardContent className="p-4 pt-2">
          <div className="text-2xl font-bold">{stats?.count || 0}</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatsCards;
